import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { db } from '../firebaseConfig/firebase';
import { collection, query, where, getDocs, doc, writeBatch } from "firebase/firestore";
import { Form, Alert, ProgressBar, Container } from 'react-bootstrap';
import Header from './Header';

function UpdateEvaluations() {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: '', msg: '' });
    const [progress, setProgress] = useState(0);

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);
        setStatus({ type: 'info', msg: 'Procesando archivo...' });
        setProgress(0);

        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const data = event.target.result;
                const workbook = XLSX.read(data, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

                await updateDatabase(excelData);
            } catch (error) {
                console.error(error);
                setStatus({ type: 'danger', msg: 'Error al leer el Excel' });
                setLoading(false);
            }
        };
        reader.readAsBinaryString(file);
    };

    const updateDatabase = async (data) => {
        let actualizados = 0;
        let errores = 0;

        let batch = writeBatch(db);
        let count = 0;

        // Función auxiliar para promediar (evita errores si el dato no es número)
        const calcularMedia = (arr) => {
            const valores = arr.map(v => parseFloat(v) || 0);
            const suma = valores.reduce((a, b) => a + b, 0);
            return suma / valores.length;
        };

        for (let i = 0; i < data.length; i++) {
            const fila = data[i];
            const email = fila.EMAIL_ALUMNO?.trim();

            const trabajoEquipo = parseFloat(fila.TRABAJO_EQUIPO) || 0;
            const responsable = parseFloat(fila.RESPONSABLE) || 0;

            if (!email) continue;

            try {
                const q = query(collection(db, "tribu-esp"), where("EMAIL_ALUMNO", "==", email));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    for (const documento of querySnapshot.docs) {
                        const dataDoc = documento.data();
                        const docRef = doc(db, "tribu-esp", documento.id);

                        // 1. Recuperar notas existentes en Firestore
                        const capDefender = parseFloat(dataDoc.CAPACIDAD_DEFENDER) || 0;
                        const motivacion = parseFloat(dataDoc.MOTIVACION_PERSONAL) || 0;
                        const notaPortfolio = parseFloat(dataDoc.NOTA_PORTFOLIO) || 0;
                        const notaExp = parseFloat(dataDoc.NOTA_EXP) || 0;

                        // 2. Calcular NOTA_ENTREVISTA (Media de 4 notas)
                        const notaEntrevista = calcularMedia([
                            trabajoEquipo,
                            responsable,
                            capDefender,
                            motivacion
                        ]);

                        // 3. Calcular TOTAL_CANDIDATO (Media de 3 notas)
                        const totalCandidato = calcularMedia([
                            notaEntrevista,
                            notaPortfolio,
                            notaExp
                        ]);

                        // 4. Preparar actualización
                        batch.update(docRef, {
                            TRABAJO_EQUIPO: trabajoEquipo,
                            RESPONSABLE: responsable,
                            NOTA_ENTREVISTA: Number(notaEntrevista.toFixed(2)),
                            TOTAL_CANDIDATO: Number(totalCandidato.toFixed(2))
                        });

                        actualizados++;
                        count++;

                        if (count >= 400) {
                            await batch.commit();
                            batch = writeBatch(db);
                            count = 0;
                        }
                    }
                } else {
                    console.warn(`No se encontró alumno con email: ${email}`);
                    errores++;
                }
            } catch (err) {
                console.error("Error en fila:", i, err);
                errores++;
            }

            setProgress(Math.round(((i + 1) / data.length) * 100));
        }

        if (count > 0) {
            await batch.commit();
        }

        setStatus({
            type: 'success',
            msg: `Proceso terminado. Actualizados: ${actualizados}. No encontrados: ${errores}`
        });
        setLoading(false);
    };

    return (
        <>
            <Header />
            <Container>
                <div className="p-4 border rounded bg-light mt-4">
                    <h5 className="mb-3">Actualizar Evaluación (Trabajo en Equipo y Responsable)</h5>

                    <Alert variant="info" className="small">
                        El archivo Excel debe contener exactamente estas columnas:
                        <br />
                        <strong>EMAIL_ALUMNO</strong>, <strong>TRABAJO_EQUIPO</strong> y <strong>RESPONSABLE</strong>
                    </Alert>

                    <Form.Group className="mb-3">
                        <Form.Label>Selecciona el archivo Excel</Form.Label>
                        <Form.Control
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileUpload}
                            disabled={loading}
                        />
                    </Form.Group>

                    {loading && (
                        <div className="mb-3">
                            <p className="small mb-1">Actualizando registros... {progress}%</p>
                            <ProgressBar animated now={progress} />
                        </div>
                    )}

                    {status.msg && (
                        <Alert variant={status.type} onClose={() => setStatus({ type: '', msg: '' })} dismissible>
                            {status.msg}
                        </Alert>
                    )}
                </div>
            </Container>
        </>
    );
}

export default UpdateEvaluations;